export default __webpack_public_path__ + "static/media/Uni_Coll_1996_2020.4af41e49.csv";